import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { PreferenceDataService } from '@seahorse/domain';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DashboardResolver {
  private _preferenceDataService = inject(PreferenceDataService);
  private _router = inject(Router);

  resolve(): Observable<boolean> {
    return this._preferenceDataService.getDashboardPreference(false).pipe(
      map((res) => {
        if (res.hasResult) {
          this._router.navigate(['/custom-dashboard']);
          return true;
        } else {
          return false;
        }
      })
    );
  }
}
